module.exports = __webpack_public_path__ + "img/w5.7cfa7d17.png";